import React from "react";
import { getPropertyName } from "css-to-react-native";
import _ from "lodash";

function isNumber(value) {
  var _int = parseFloat(value);

  var _string = _int.toString();

  return _string === value;
}

export function processStyles(styles) {
  var processed = {};

  _.each(styles, function (item, idx) {
    var propertyName = getPropertyName(idx);

    if (propertyName == "backgroundImage" && item != "") {
      item = "url(" + encodeURI(item) + ")";
    }

    if (isNumber(item)) {
      item = parseFloat(item);
    }

    processed[propertyName] = item;
  });

  return processed;
}
export function commonSelectOptions(options) {
  var firstOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var compiledOptions = [/*#__PURE__*/React.createElement("option", {
    key: _.uniqueId("def_")
  })];

  if (firstOption) {
    compiledOptions[0] = firstOption;
  }

  _.each(options, function (title, value) {
    compiledOptions.push( /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, title));
  });

  return compiledOptions;
}